import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import { prop, take } from "ramda";

const getArticlesByCategoryWidget = (category) =>
  getWidgetByName("articlelistingbycategorywidget", category)
    .then(Articles)
    .then(prop("articles"));

export { getArticlesByCategoryWidget };
